import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=745c0dc5&"
import script from "./ProfileEdit.vue?vue&type=script&lang=js&"
export * from "./ProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=745c0dc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports